import React, { PureComponent } from 'react';
import { Form, Text, TextArea } from 'informed';
import shortid from 'shortid';
import ContactManager from '../managers/ContactManager';
import ContactPHP from '../helper/ContactPHP';

const validateName = (name) => {
  if (!name) {
    return 'Required Field';
  }

  if (name.length <= 2) {
    return 'Name too short';
  }

  if (name.length >= 70) {
    return 'Name too long';
  }

  const re = /^[a-zA-Z '.-]*$/;
  if (!re.test(name)) {
    return 'Invalid Name';
  }

  return null;
};

const validateEmail = (email) => {
  if (!email) {
    return 'Required Field';
  }

  if (email.length >= 70) {
    return 'Email too long';
  }

  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!re.test(email)) {
    return 'Invalid Email';
  }

  return null;
};

const validateMessage = (message) => {
  if (!message) {
    return 'Required Field';
  }
  if (message.length <= 2) {
    return 'Message too short';
  }

  if (message.length >= 3000) {
    return 'Message too long';
  }

  return null;
};

class Contact extends PureComponent {
  constructor() {
    super();
    this.contact = new ContactManager();
    this.form = this.contact.getForm();
    this.formSubmit = this.formSubmit.bind(this);
    this.contactPHP = new ContactPHP();
    this.loading = false;
    this.state = {
      submit: false,
    };
  }

  getForm() {
    return (
      <div className="font-title-bold contact__content--right">
        <Form id="validate-form">
          {({ formApi, formState }) => (
            <div>
              <div className="contact__form__label" htmlFor="validate-name">
                {this.form.getName()}
              </div>
              <Text
                className="font-paragraph contact__form__field"
                field="name"
                id="validate-name"
                validate={validateName}
              />
              <div className="font-paragraph contact__form__error">
                {JSON.stringify(formState.errors.name)}
              </div>

              <div
                className="contact__form__label contact__form__label__top"
                htmlFor="validate-email"
              >
                {this.form.getEmail()}
              </div>
              <Text
                className="font-paragraph  contact__form__field"
                field="email"
                id="validate-email"
                validate={validateEmail}
              />
              <div className="font-paragraph contact__form__error">
                {JSON.stringify(formState.errors.email)}
              </div>

              <div
                className="contact__form__label contact__form__label__top"
                htmlFor="validate-message"
              >
                {this.form.getMessagte()}
              </div>

              <TextArea
                className="font-paragraph   contact__form__field contact__form__field__message"
                field="message"
                id="validate-message"
                validate={validateMessage}
              />

              <div className="font-paragraph contact__form__error">
                {JSON.stringify(formState.errors.message)}
              </div>
              <div className="contact__form__submit__top" />
              <button
                type="submit"
                className="font-title-semi_bold contact__form__submit"
                onClick={() => {
                  formApi.submitForm();
                  this.formSubmit(formState);
                }}
              >
                {this.form.getSubmit()}
              </button>
            </div>
          )}
        </Form>
      </div>
    );
  }

  getMessage() {
    return (
      <div>
        {this.contact.getMessage().map(message => (
          <div key={`div-${shortid.generate()}`}>
            <div className="font-paragraph">{message}</div>
            <div className="contact__space">&nbps;</div>
          </div>
        ))}
      </div>
    );
  }

  formSubmit(formData) {
    const { errors } = formData;
    if (errors.name || errors.email || errors.message) {
      console.log(errors);
    } else {
      // TODO: Make this work to handel errors and send email on the php side
      this.contactPHP.saveData(formData.values);
      this.setState({
        submit: true,
      });
    }
  }

  render() {
    const { submit } = this.state;
    return (
      <div className="contact contact__bg_image">
        <div className="font-title-semi_bold contact__title">{this.contact.getTitle()}</div>
        {!submit ? (
          <div className="contact__content contact__left">
            <div className="contact__content--left">
              {this.getMessage()}
              <div className="font-title-bold contact__center contact__content__name">
                {this.contact.getName()}
              </div>
              <div className="contact__center font-paragraph-italic">{this.contact.getEmail()}</div>
            </div>
            {this.getForm()}
          </div>
        ) : (
          <div className="font-title-semi_bold contact__title">Thank You</div>
        )}
        <div className="contact__bottom_pad" />
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js